import { lazy } from 'react';

export const ReleasesRoutes = {
  Releases: lazy(() =>
    import('@/modules/Releases/pages/Releases').then(({ Releases }) => ({
      default: Releases,
    })),
  ),
};
